// extracted by mini-css-extract-plugin
module.exports = {"container":"_1KFbkBVeecHCQmi64YPyfd","cancelBtn":"GlpMJ-xmi-AAPUrf0Jo_s","icon":"_3X_zjebLU9K3DteBo3f5Gr","saveBtn":"_3GCxuT10bgSbAYXmG5tzfp"};